import moment from "moment";

export const MISSIONS = [
  {
    id: "dccm",
    name: "Tamil Nadu Climate Change Mission (DCCM)",
    color: "#FDF2E9",
    metrics: [
      { id: "awareness_activities", label: "No of awareness activities under DCCM", type: "number", required: true },
      { id: "green_schools_count", label: "Number of Green Schools", type: "number", required: true },
      { id: "green_school_status", label: "Green School Status", type: "text", required: true },
      { id: "monthly_meetings", label: "DCCM Monthly Meetings", type: "number", required: true },
      { id: "green_days", label: "Green Days Observed if any with Name and details", type: "text", multiline: true, required: true },
      { id: "manjappai_initiative", label: "“Meendum Manjappai” Initiative", type: "text", required: true },
      { id: "manjappai_bags", label: "No of Manjappai Bags distributed", type: "number", required: true },
      { id: "blue_green_centre", label: "Blue Green Centre Status", type: "text", required: true },
      { id: "blue_flag_beach", label: "Blue Flag Beach Status (Applicable only for Coastal Districts)", type: "text", required: true },
      { id: "training_programme", label: "DCCM - Training programme", type: "text", multiline: true, required: true },
      { id: "capacity_building", label: "DCCM - Capacity building programme", type: "text", multiline: true, required: true },
    ],
  },

  {
    id: "wetlands",
    name: "Tamil Nadu Wetlands Mission",
    color: "#EBF5FB",
    metrics: [
      { id: "wetlands_isro", label: "Number of Wetlands (as per ISRO list)", type: "number", required: true },
      { id: "wetlands_ground_truthed", label: "Number of Wetlands Ground-truthed", type: "number", required: true },
      { id: "wetlands_restored", label: "Wetlands Restored", type: "number", required: true },
      { id: "wetland_mithras", label: "Number of Wetland Mithras", type: "number", required: true },
      { id: "awareness_tnwm", label: "Awareness Programme under TNWM", type: "text", multiline: true, required: true },
    ],
  },

  {
    id: "green_tn",
    name: "Green Tamil Nadu Mission",
    color: "#E9F7EF",
    metrics: [
      { id: "yearly_target", label: "Yearly Target", type: "number", required: true },
      { id: "area_cultivated", label: "Area Cultivated (in hectares)", type: "number", required: true },
      { id: "saplings_planted", label: "Number of Saplings Planted", type: "number", required: true },
      { id: "saplings_geotagged", label: "Number of Saplings Geo-tagged", type: "number", required: true },
      { id: "survival_rate", label: "Survival Rate (%)", type: "number", required: true },
      { id: "geotag_training", label: "Training Programme for Geo-tagging", type: "text", multiline: true, required: true },
      { id: "seed_balls", label: "Seed Balls Distribution", type: "number", required: true },
      { id: "palm_seedlings", label: "Palm Tree Seedlings Planted", type: "number", required: true },
      { id: "awareness_gtm", label: "Awareness Programme under GTM", type: "text", multiline: true, required: true },
    ],
  },

  {
    id: "mpcd",
    name: "Massive Plastic Collection Drive (Month-wise)",
    color: "#FDEDEC",
    metrics: [
      { id: "is_applicable", label: "Is it Applicable?", type: "dropdown", options: ["Applicable", "Not Applicable"], required: true },
      { id: "mpcd_date", label: "Date of the MPCD Drive", type: "date", required: true },
      { id: "participants_children", label: "No. of Participants (Children)", type: "number", required: true },
      { id: "participants_adults", label: "No. of Participants (Adults)", type: "number", required: true },
      { id: "manjappai_distribution", label: "No. of Manjappai Distribution", type: "number", required: true },
      { id: "pamphlets_distribution", label: "No. of Pamphlet/Brochures Distribution", type: "number", required: true },
      { id: "total_waste", label: "Quantity of Total Waste Collected (Kg)", type: "number", required: true },
      { id: "plastic_waste", label: "Quantity of Total Plastic Waste Collected (Kg)", type: "number", required: true },
      { id: "other_waste", label: "Quantity of Other Waste Collected (Kg)", type: "number", required: true },
      { id: "plastic_recycling", label: "Plastic Waste Sent to Recycling (Kg)", type: "number", required: true },
      { id: "plastic_coprocessing", label: "Plastic Waste Sent to Co-processing (Kg)", type: "number", required: true },
      { id: "awareness_mpcd", label: "Awareness Programme under MPCD", type: "text", multiline: true, required: true },
    ],
  },

  {
    id: "district_admin",
    name: "District Administration Works",
    color: "#F4F6F7",
    metrics: [
      {
        id: "district_works",
        label: "Mention the district administration works carried out",
        type: "text",
        multiline: true,
        required: true,
      },
    ],
  },
];


export const getWeeksForMonth = (monthName, year) => {
  return [
    {
      id: "monthly",
      label: "Monthly Progress",
      range: `Full Month of ${monthName}`,
    }
  ];
};

export const WEEKS = getWeeksForMonth(moment().format("MMMM"), moment().format("YYYY"));
export const CURRENT_MONTH_NAME = moment().format("MMMM YYYY");
